<template>
    <div>
        <div class="row setting">
            <div class="col col-50">
                <span class="subtitle">Factuur {{ invoice.id }}</span><br/>
                &euro; {{ invoice.price }}
            </div>
            <div class="col col-50">
                fsdff
            </div>
        </div>
    </div>
</template>

<script>
    export default {
    name: 'Invoice',
        data () {
            
            return {
                invoice: []
            }
        },
        
        mounted(){
            
            
        },
        
        created(){
            
            this.getInvoice();
        },
        
        methods:{
            
            getInvoice(){
                
                var id = this.$route.params.id;
                
                this.$api.get('/invoices?id='+id)
                .then(response => {
                    
                    this.invoice = response.data;
                })
                .catch(e => {
                
                })  
            },
            
            export_data: function(title){
                
                var root = this.$root;
                var _this = this;
                
                this.$api.post('/download/prepare', {
                    service: 'invoices/export'
                })
                .then(response => {

                    _this.$root.ui.showDialog(
                        'Downloaden', 
                        title, 
                        true,
                        {
                            0: {
                                name: 'PDF bestand',
                                action: response.data.url,
                                execute: function(){}
                            }
                        }
                    );
                })
                .catch(e => {
                    
                    _this.$root.ui.showDialog(
                        'Fout',
                        'Unable to load config.',
                        true
                    );
                })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/invoices/Invoice.vue